module.exports = __webpack_public_path__ + "img/GoodFirms.68aff9f4.webp";